import { render, staticRenderFns } from "./dialoglabel.vue?vue&type=template&id=b51d366e&scoped=true"
import script from "./dialoglabel.vue?vue&type=script&lang=js"
export * from "./dialoglabel.vue?vue&type=script&lang=js"
import style0 from "./dialoglabel.vue?vue&type=style&index=0&id=b51d366e&prod&lang=less&scoped=true"
import style1 from "./dialoglabel.vue?vue&type=style&index=1&id=b51d366e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d366e",
  null
  
)

export default component.exports